import React from "react";
import "../CustomTheme/customTheme.css";
import "./CustomButton.css";

/*
 * variant: "primary" | "secondary" | "outline" | "danger" | "danger-solid" | "ghost" | "link"
 *          ("outline-primary" still works — same as "outline")
 * size:    "sm" | "md" | "lg"   (md is the same height as inputs)
 */

const CustomButton = React.forwardRef(
  (
    {
      children,
      label,
      variant = "primary",
      size = "md",
      loading = false,
      disabled = false,
      icon,
      iconPosition = "left",
      fullWidth = false,
      type = "button",
      colClass,
      className,
      style,
      onClick,
      ...rest
    },
    ref
  ) => {
    const isDisabled = disabled || loading;
    const childrenIsBareIcon = React.isValidElement(children) && label == null;
    const effectiveIcon = icon ?? (childrenIsBareIcon ? children : undefined);
    const content = childrenIsBareIcon ? null : (children ?? label);
    const isIconOnly = !content && Boolean(effectiveIcon);

    const button = (
      <button
        ref={ref}
        type={type}
        disabled={isDisabled}
        onClick={onClick}
        aria-label={isIconOnly ? rest.title : undefined}
        className={`cbtn cbtn-${variant} cbtn-${size}${fullWidth ? " cbtn-full" : ""}${
          loading ? " cbtn-loading" : ""
        }${isIconOnly ? " cbtn-iconOnly" : ""}${className ? ` ${className}` : ""}`}
        style={style}
        {...rest}
      >
        {loading ? (
          <span className="cbtn-spinner" aria-hidden="true" />
        ) : (
          effectiveIcon &&
          (iconPosition === "left" || isIconOnly) && (
            <span className="cbtn-icon cbtn-icon-left">{effectiveIcon}</span>
          )
        )}

        {content && <span className="cbtn-label">{content}</span>}

        {!loading && effectiveIcon && iconPosition === "right" && !isIconOnly && (
          <span className="cbtn-icon cbtn-icon-right">{effectiveIcon}</span>
        )}
      </button>
    );

    return colClass ? <div className={colClass}>{button}</div> : button;
  }
);

CustomButton.displayName = "CustomButton";

export default React.memo(CustomButton);